import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { QueryConfig, TransactionTypeDto } from 'types';

export const getTransactionType = ({ id }: { id: string }) => {
  return httpv2.get<TransactionTypeDto>(`transaction-types/${id}`);
};

export const getTransactionTypeQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ['transaction-types', id],
    queryFn: () => getTransactionType({ id }),
  });
};

interface UseTransactionTypeOptions {
  id: string;
  queryConfig?: QueryConfig<typeof getTransactionTypeQueryOptions>;
}

export const useSuspenseTransactionType = ({ id, queryConfig }: UseTransactionTypeOptions) => {
  return useSuspenseQuery({
    ...getTransactionTypeQueryOptions(id),
    ...queryConfig,
  });
};
